module.exports = __webpack_public_path__ + "static/cartorio-logo-940e5db3b27b5a8c9efac168b7c480ba.png";